// extracted by mini-css-extract-plugin
export default {"loading_div":"AppAuth_loading_div__AGBQ6","login_wrapper":"AppAuth_login_wrapper__tSRZ-","logo":"AppAuth_logo__cRrtd"};